import type { ApiClient } from "./client";
import type { HeartbeatResponse, ReadyResponse } from "./types";

const BASE = "/api/v1/health";

export function createHealthService(client: ApiClient) {
  return {
    getHeartbeat: () => client.fetch<HeartbeatResponse>(`${BASE}/heartbeat`),
    getReadiness: () => client.fetch<ReadyResponse>(`${BASE}/ready`),
  };
}

export type HealthService = ReturnType<typeof createHealthService>;
